import { render, staticRenderFns } from "./TotalView.vue?vue&type=template&id=7f55ccfb&"
import script from "./TotalView.vue?vue&type=script&lang=js&"
export * from "./TotalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports